'use client'

import dynamic from 'next/dynamic'
import { Stepper, Step, StepLabel, Typography } from '@mui/material'

// Types
import type { StepperProps } from '@/types/components/molecules/timeline/stepper'

// Fonts


// Components
const StepAtom = dynamic(() => import('@/components/atoms/items/step'))
const ConnectorAtom = dynamic(() => import('@/components/atoms/items/connector'))

const StepperMolecule = (props: StepperProps) => {
	// Props
	const { items, activeStep, loading, onClick } = props

	return (
		<Stepper
			activeStep={activeStep}
			connector={<ConnectorAtom />}
			sx={{
				cursor: 'pointer',
				flexDirection: { xs: 'row', md: 'column' },
				alignItems: { md: 'stretch' },
				width: 'fit-content',
				maxWidth: 1,
				overflow: 'auto',
				py: 1.25
			}}
		>
			{items.map((item, index) => {
				if (index)
					return (
						<Step
							key={index}
							disabled={loading}
							onClick={() => onClick(item.toString())}
							sx={{
								'&:hover .step-atom': {
									bgcolor: 'primary.dark',
									'&.active': {
										bgcolor: 'transparent',
										outlineColor: 'primary.dark'
									}
								}
							}}
						>
							<StepLabel icon={<StepAtom isActive={index === activeStep} />} sx={{ p: 0 }}>
								<Typography component="span">
									{item}
								</Typography>
							</StepLabel>
						</Step>
					)
				else return null
			})}
		</Stepper>
	)
}

export default StepperMolecule
